/* AV1b — graine repliée. Les avis restent dans le DOM pour les robots. */
(function () {
  var PLACEHOLDER = "987654";
  var MAX_LOADS = 8;
  var EMPTY_WAIT = 1600;
  var copy = {
    see: "Voir les " + PLACEHOLDER,
    read: "Lire les voix",
    hide: "Replier",
    write: "Écrire un avis",
    score: "RATING · " + PLACEHOLDER + " voix",
    heading: "Ils l'ont goûté",
    mark: ""
  };
  var node = document.getElementById("moojo-reviews-fold-copy");
  if (node) {
    try {
      copy = JSON.parse(node.textContent);
    } catch (e) {}
  }
  function unescapeHtml(s) {
    return String(s || "")
      .replace(/&amp;/g, "&")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&apos;/g, "'")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">");
  }
  copy.see = unescapeHtml(copy.see);
  copy.read = unescapeHtml(copy.read);
  copy.hide = unescapeHtml(copy.hide);
  copy.write = unescapeHtml(copy.write);
  copy.score = unescapeHtml(copy.score);
  copy.heading = unescapeHtml(copy.heading);

  var timer = 0;
  var mode = "closed";
  var takenOver = false;
  var expanding = false;
  var bound = false;
  var emptyReady = false;
  var emptyTimer = 0;

  function labelSee(n) {
    if (copy.read) return copy.read;
    return String(copy.see || "")
      .split(PLACEHOLDER).join(String(n))
      .split("987.654").join(String(n))
      .split("987 654").join(String(n));
  }

  function labelScore(rating, n) {
    return String(copy.score || "")
      .split("RATING").join(String(rating || "5/5"))
      .split(PLACEHOLDER).join(String(n))
      .split("987.654").join(String(n))
      .split("987 654").join(String(n));
  }

  function countFrom(root) {
    var countEl = root.querySelector(".kl_reviews__summary__stars__count");
    if (countEl) {
      var fromCount = (countEl.textContent || "").match(/(\d+)/);
      if (fromCount) return parseInt(fromCount[1], 10);
    }
    var tab = root.querySelector(".kl_reviews__list__tab");
    if (tab) {
      var fromTab = (tab.textContent || "").match(/(\d+)/);
      if (fromTab) return parseInt(fromTab[1], 10);
    }
    var box = root.querySelector(".kl_reviews__summary__average_and_stars");
    if (!box) return null;
    var text = (box.textContent || "").replace(/\s+/g, " ").trim();
    var named = text.match(/(\d+)\s*(avis|reviews?|bewertungen|bewertung|reseñas|reseña|レビュー|件)/i);
    if (named) return parseInt(named[1], 10);
    return null;
  }

  function itemsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll(".kl_reviews__review_item"));
  }

  function recognized(root) {
    return !!(
      root.querySelector(".kl_reviews__summary__average_and_stars") &&
      root.querySelector(".kl_reviews__histogram") &&
      root.querySelector(".kl_reviews__list_container")
    );
  }

  function siblingsOk(items) {
    if (items.length < 2) return true;
    var parent = items[0].parentElement;
    for (var i = 1; i < items.length; i++) {
      if (items[i].parentElement !== parent) return false;
    }
    return true;
  }

  function companyId() {
    var scripts = document.querySelectorAll("script[src]");
    for (var i = 0; i < scripts.length; i++) {
      var m = String(scripts[i].src).match(/klaviyo\.js\?company_id=([A-Za-z0-9]+)/);
      if (m) return m[1];
    }
    return null;
  }

  function reviewLang() {
    var lang = (document.documentElement.lang || "fr").trim().toLowerCase().replace("_", "-");
    var mapped = { fr: "fr-fr", en: "en-us", nl: "nl-nl", de: "de-de", es: "es-es", ja: "ja-jp" };
    if (mapped[lang]) return mapped[lang];
    if (lang.indexOf("-") === -1) return lang + "-" + lang;
    return lang;
  }

  function writeUrl(root) {
    var cid = companyId();
    var pid = root.getAttribute("data-id");
    if (!cid || !pid) return null;
    return (
      "https://reviews-app.services.klaviyo.com/rr/" +
      encodeURIComponent(pid) +
      "?company_id=" +
      encodeURIComponent(cid) +
      "&lang=" +
      encodeURIComponent(reviewLang()) +
      "&onsiteEnabled=true"
    );
  }

  function ensureWriteStyle() {
    if (document.getElementById("moojo-reviews-write-style")) return;
    var style = document.createElement("style");
    style.id = "moojo-reviews-write-style";
    style.textContent = [
      ".kl_reviews__submission_modal__overlay{position:fixed;inset:0;z-index:1000000;display:flex;align-items:center;justify-content:center;background:rgba(20,20,20,.8);padding:1rem}",
      ".kl_reviews__submission_modal__frame{width:min(575px,100%);height:min(720px,calc(100vh - 2rem));border:0;background:#fff}"
    ].join("");
    document.head.appendChild(style);
  }

  function openWrite(root) {
    var native = root.querySelector(".kl_reviews__button");
    if (native) {
      native.click();
      return;
    }
    var url = writeUrl(root);
    if (!url) return;
    var overlay = document.querySelector(".kl_reviews__submission_modal__overlay");
    if (overlay) overlay.remove();
    ensureWriteStyle();
    overlay = document.createElement("div");
    overlay.className = "kl_reviews__submission_modal__overlay";
    var frame = document.createElement("iframe");
    frame.className = "kl_reviews__submission_modal__frame";
    frame.title = "Écrire un avis";
    frame.src = url;
    overlay.appendChild(frame);
    function closeWrite() {
      overlay.remove();
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("message", onMessage);
    }
    function onKey(event) {
      if (event.key !== "Escape") return;
      closeWrite();
    }
    overlay.addEventListener("click", function (event) {
      if (event.target === overlay) closeWrite();
    });
    function onMessage(event) {
      if (event.origin !== "https://reviews.klaviyo.com") return;
      if (event.data !== "close") return;
      closeWrite();
    }
    document.addEventListener("keydown", onKey);
    window.addEventListener("message", onMessage);
    document.body.appendChild(overlay);
  }

  function removeButton(root) {
    var button = root.querySelector(".moojo-reviews-fold");
    if (button) button.remove();
  }

  function removeEmpty(root) {
    var empty = root.querySelector(".moojo-reviews-empty");
    if (empty) empty.remove();
  }

  function removeHeading(root) {
    var intro = root.querySelector(".moojo-reviews-intro");
    if (intro) intro.remove();
    var heading = root.querySelector(".moojo-reviews-heading");
    if (heading) heading.remove();
  }

  function ensureHeading(root) {
    var text = copy.heading || "";
    if (!text) {
      removeHeading(root);
      return;
    }
    var box = root.querySelector(".reviews_all_container") || root;
    var intro = root.querySelector(".moojo-reviews-intro");
    var heading;
    if (!intro) {
      intro = document.createElement("div");
      intro.className = "moojo-reviews-intro";
      box.insertBefore(intro, box.firstChild);
    }
    if (copy.mark) {
      var mark = intro.querySelector(".moojo-reviews-mark");
      if (!mark) {
        mark = document.createElement("img");
        mark.className = "moojo-reviews-mark";
        mark.alt = "";
        mark.setAttribute("aria-hidden", "true");
        intro.insertBefore(mark, intro.firstChild);
      }
      mark.setAttribute("width", "128");
      mark.setAttribute("height", "80");
      if (mark.getAttribute("src") !== copy.mark) mark.setAttribute("src", copy.mark);
    }
    heading = intro.querySelector(".moojo-reviews-heading");
    if (!heading) {
      heading = document.createElement("h2");
      heading.className = "moojo-reviews-heading h4";
      intro.appendChild(heading);
    } else {
      heading.classList.add("h4");
    }
    if (heading.textContent !== text) heading.textContent = text;
  }

  function ensureSeed(root, total) {
    var intro = root.querySelector(".moojo-reviews-intro");
    if (!intro) return;
    var seed = intro.querySelector(".moojo-reviews-seed");
    if (mode !== "closed") {
      if (seed) seed.remove();
      return;
    }
    var ratingEl = root.querySelector(".kl_reviews__summary__average_value");
    var rating = ratingEl
      ? (ratingEl.textContent || "").replace(/\s+/g, " ").trim()
      : "";
    if (!rating) rating = "5/5";
    else if (!/\//.test(rating) && /^\d+([.,]\d+)?$/.test(rating)) rating = rating + "/5";
    var text = labelScore(rating, total);
    if (!seed) {
      seed = document.createElement("p");
      seed.className = "moojo-reviews-seed";
      intro.appendChild(seed);
    }
    if (seed.textContent !== text) seed.textContent = text;
  }

  function ensureButton(root, total) {
    var listBlock = root.querySelector(".kl_reviews__reviews_list");
    if (!listBlock || !listBlock.parentElement) return;
    var wrap = root.querySelector(".moojo-reviews-fold");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "moojo-reviews-fold";
      var button = document.createElement("button");
      button.type = "button";
      button.className = "moojo-reviews-fold__button";
      button.addEventListener("click", function () {
        toggle(root);
      });
      wrap.appendChild(button);
      listBlock.parentElement.insertBefore(wrap, listBlock.nextSibling);
    }
    var button = wrap.querySelector("button");
    var text = mode === "open" ? copy.hide || "Replier" : labelSee(total);
    if (button.textContent !== text) button.textContent = text;
    button.setAttribute("aria-expanded", mode === "open" ? "true" : "false");
  }

  function ensureEmpty(root) {
    if (root.querySelector(".kl_reviews__button")) {
      removeEmpty(root);
      return;
    }
    var wrap = root.querySelector(".moojo-reviews-empty");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "moojo-reviews-empty";
      var button = document.createElement("button");
      button.type = "button";
      button.className = "moojo-reviews-fold__button";
      button.addEventListener("click", function () {
        openWrite(root);
      });
      wrap.appendChild(button);
      root.appendChild(wrap);
    }
    var button = wrap.querySelector("button");
    var text = copy.write || "Écrire un avis";
    if (button.textContent !== text) button.textContent = text;
  }

  function markHidden(root) {
    var items = itemsOf(root);
    for (var i = 0; i < items.length; i++) {
      if (mode === "closed") items[i].classList.add("moojo-review-folded");
      else items[i].classList.remove("moojo-review-folded");
    }
  }

  function apply() {
    try {
      var root = document.getElementById("fulfilled-reviews-all");
      if (!root || expanding) return;
      var items = itemsOf(root);
      if (recognized(root) && items.length && siblingsOk(items)) {
        emptyReady = true;
        removeEmpty(root);
        watch(root);
        var total = countFrom(root);
        if (total === null) total = items.length;
        if (total <= 0) {
          root.setAttribute("data-moojo-reviews-fold", "empty");
          ensureHeading(root);
          ensureEmpty(root);
          return;
        }
        ensureHeading(root);
        if (takenOver) {
          mode = "open";
          root.setAttribute("data-moojo-reviews-fold", "open");
          markHidden(root);
          ensureSeed(root, total);
          removeButton(root);
          return;
        }
        root.setAttribute("data-moojo-reviews-fold", mode);
        markHidden(root);
        ensureSeed(root, total);
        ensureButton(root, total);
        return;
      }
      if (root.querySelector(".reviews_all_container")) return;
      if (!emptyReady) {
        if (!emptyTimer) {
          emptyTimer = window.setTimeout(function () {
            emptyReady = true;
            emptyTimer = 0;
            apply();
          }, EMPTY_WAIT);
        }
        return;
      }
      root.setAttribute("data-moojo-reviews-fold", "empty");
      ensureHeading(root);
      ensureEmpty(root);
    } catch (e) {}
  }

  function watch(root) {
    if (bound) return;
    bound = true;
    function release(ev) {
      if (ev.target.closest(".moojo-reviews-fold, .moojo-reviews-empty")) return;
      if (!ev.target.closest(".kl_reviews__filters, .kl_reviews__list__tab_buttons")) return;
      takenOver = true;
      mode = "open";
      root.setAttribute("data-moojo-reviews-fold", "open");
      removeButton(root);
    }
    root.addEventListener("click", release, true);
    root.addEventListener("change", release, true);
  }

  function loadRest(root, total) {
    expanding = true;
    var tries = 0;
    function step() {
      var more = root.querySelector(".kl_reviews__load_more_button button");
      var n = itemsOf(root).length;
      if (!more || n >= total || tries >= MAX_LOADS) {
        expanding = false;
        apply();
        return;
      }
      var before = n;
      tries += 1;
      more.click();
      var waits = 0;
      function waitGrow() {
        var now = itemsOf(root).length;
        var still = root.querySelector(".kl_reviews__load_more_button button");
        if (now > before || !still || waits >= 10) {
          step();
          return;
        }
        waits += 1;
        window.setTimeout(waitGrow, 300);
      }
      window.setTimeout(waitGrow, 300);
    }
    step();
  }

  function toggle(root) {
    var total = countFrom(root) || itemsOf(root).length;
    if (mode === "closed") {
      mode = "open";
      root.setAttribute("data-moojo-reviews-fold", "open");
      markHidden(root);
      ensureSeed(root, total);
      ensureButton(root, total);
      loadRest(root, total);
    } else {
      mode = "closed";
      root.setAttribute("data-moojo-reviews-fold", "closed");
      markHidden(root);
      ensureSeed(root, total);
      ensureButton(root, total);
    }
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(apply, 80);
  }

  if (!document.body) return;
  new MutationObserver(function () {
    if (!expanding) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  schedule();
})();
